<template>
    <div class="videos">
        <div class="videos-header">
            NEWS VIDEOS
        </div>
        <div class="videos-main" v-if="main">
            <a :href="main.url" @click.prevent.stop="openVideoModal(main)">
                <div class="videos-main-image">
                    <img :src="main.media_large">
                </div>
                <div class="videos-main-title">
                    {{ main.title }}
                </div>
            </a>
        </div>
        <div class="videos-list-container" v-if="extra.length">
            <div class="videos-list-element" v-for="video in extra" @click.prevent.stop="openVideoModal(video)">
                <a :href="video.url">
                    <div class="videos-thumbnail">
                        <img :src="video.media_small">
                    </div>
                    <div class="videos-element-title">
                        <div class="videos-element-category">News</div>
                        <div class="videos-element-title-link">{{ video.title }}</div>
                    </div>
                </a>
            </div>
        </div>
        <video-modal :open="videoModal" :close="closeVideoModal" :videoOpen="videoOpen"></video-modal>
    </div>
</template>

<script>
    import axios from "axios";
	import VideoModal from "../shared/video-modal.vue";

    export default {
    	components: {
			VideoModal
        },
        data () {
    	    return {
    	    	videoModal: false,
                videosResults: [],
                videoOpen: null
            }
        },
        created () {
    		if (window.__VIDEO_CACHE) {
				this.videosResults = window.__VIDEO_CACHE;
            } else {
				axios.get("/wp-json/news/v1/videos", {
					params: {
						amount: 5
					}
				})
					.then(({data}) => {
						let ids = data.map((post) => {
							return post.customs.youtube_id
						});
						this.fetchVideoData(ids);
					});
            }
        },
        computed: {
    	    main () {
    	    	return this.videosResults[0]
            },
            extra () {
    	    	return this.videosResults.slice(1,4);
            }
        },
        methods: {
    		fetchVideoData (ids) {
				axios.get('https://www.googleapis.com/youtube/v3/videos', {
					params: {
						part: ["snippet"].join(","),
						id: ids.join(","),
						key: "AIzaSyAlVq6gewMJMepUvri1H3-2VQ6-NTA2jbM"
					}
				})
					.then((response) => {
						window.__VIDEO_CACHE = this.videosResults = response.data.items.map((video) => {
							return {
								id: video.id,
								title: video.snippet.localized.title,
								description: video.snippet.description,
								media_small: video.snippet.thumbnails.default.url,
								media_large: video.snippet.thumbnails.high.url,
								url: `https://www.youtube.com/watch?v=${video.id}`
							}
						});
					})
            },
    		closeVideoModal () {
				this.videoOpen = null;
    			this.videoModal = false;
            },
            openVideoModal (video) {
				this.videoOpen = video;
    			this.videoModal = true;
            }
        }
    }
</script>

<style lang="scss">
    @import "~foundation-sites/scss/foundation";
    .videos {
        background: #292929;
        padding: 1rem;
        overflow: auto;
        color: white;
    }

    .videos-main > a:hover,
    .videos-list-element > a:hover {
        color: #75aa51;
    }

    .videos-main a {
        display: block;
        color: white;
    }

    .videos-header {
        font-size: 1.1rem;
        font-weight: bolder;
        margin-bottom: .5rem;
    }

    .videos-main-image img {
        display: block;
        width: 100%;
    }
    .videos-main-image img,
    .videos-thumbnail img {
        box-shadow: -4px 5px 3px 1px rgba(0, 0, 0, 0.26);
    }

    .videos-main-title {
        font-size: 1.1rem;
        font-weight: bold;
        margin: .5rem 0;
        margin-bottom: 1rem;
    }

    .videos-list-element > a {
        display: flex;
        margin-bottom: 1rem;
        color: white;
    }

    .videos-list-element:last-child > a {
        margin-bottom: 0;
    }

    .videos-thumbnail {
        flex: 7rem 0 0;
    }

    .videos-thumbnail img {
        display: block;
    }

    .videos-element-title {
        line-height: normal;
        padding: 0 .5rem;
    }

    .videos-element-category {
        color: #577f40;
    }

    /* Small only */
    @include breakpoint(small only) {
        .videos-list-container {
            display: flex;
            flex-wrap: wrap;
        }

        .videos-element-title-link {
            font-size: 1rem;
        }

        .videos-list-element {
            flex: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// videos.vue?447771ed